import React, { FC } from 'react';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';
import { ReactComponent as BackArrowSvg } from 'assets/image/selects/blue-arrow.svg';
import styles from './ArrowBackLink.module.scss';

type ArrowBackLinkPropsType = {
	parentClassName?: string;
	onboardingStyle?: boolean;
};

const ArrowBackLink: FC<ArrowBackLinkPropsType> = ({ parentClassName, onboardingStyle }: ArrowBackLinkPropsType) => {
	const history = useHistory();

	return (
		<div
			className={cx(styles.container, 'link', parentClassName && parentClassName, {
				[styles.onboarding]: onboardingStyle,
			})}
			onClick={() => history.go(-1)}
		>
			<BackArrowSvg />
			<span>Back</span>
		</div>
	);
};

export default ArrowBackLink;
